import React from 'react';

const tones = {
  neutral: 'bg-surface-subtle text-ink-muted border-line',
  brand: 'bg-brand-subtle text-brand-ink border-brand/15',
  success: 'bg-success-subtle text-success border-success/15',
  warning: 'bg-warning-subtle text-warning border-warning/15',
  danger: 'bg-danger-subtle text-danger border-danger/15',
  info: 'bg-info-subtle text-info border-info/15',
};

/** Pastille de statut. Une seule échelle de taille pour rester homogène. */
const sizes = {
  micro: 'px-1.5 py-0.5 text-2xs font-semibold uppercase',
  data: 'px-2 py-0.5 text-xs font-semibold',
};

/** `size="data"` pour un badge qui porte une donnée lisible (nom de classe). */
const Badge = ({ children, tone = 'neutral', icon, size = 'micro', className = '' }) => (
  <span
    className={`inline-flex items-center gap-1 rounded-md border ${sizes[size] || sizes.micro} ${
      tones[tone] || tones.neutral
    } ${className}`}
  >
    {icon}
    {children}
  </span>
);

export default Badge;
